import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  picture: {
    id: 'studio.wvoA3H',
    defaultMessage: 'Picture',
  },
});
